import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, isValidElement, } from 'react';
import { Slide, toast, } from 'react-toastify';
import isString from 'lodash-es/isString';
import { DEFAULT_SNACKBAR_CONTAINER } from './constants';
import { SnackbarContent } from './SnackbarContent';
import { SnackbarAction } from './SnackbarAction';
const defaultToastOptions = {
    containerId: DEFAULT_SNACKBAR_CONTAINER,
    closeOnClick: false,
    position: 'bottom-left',
    transition: Slide,
    closeButton: false,
    draggable: false,
    autoClose: 5000,
};
const toToastOptions = (options) => ({
    ...options,
    ...defaultToastOptions,
    toastId: options?.snackbarId,
    containerId: options?.containerId ?? defaultToastOptions.containerId,
    autoClose: options?.hideAfter ?? defaultToastOptions.autoClose,
});
const mkAction = (id, action) => {
    if (isString(action)) {
        return (_jsx(SnackbarAction, { type: "button", onClick: () => toast.dismiss(id), children: action }));
    }
    if (isValidElement(action)) {
        const onClick = (event) => {
            action.props.onClick(event);
            toast.dismiss(id);
        };
        // @ts-expect-error due to mismatch between the types of onClick in ElementType
        return cloneElement(action, { onClick });
    }
    return null;
};
const toUpdateToastOptions = (options) => ({
    ...toToastOptions(options),
    render: options?.message &&
        (({ toastProps }) => (_jsx(SnackbarContent, { className: options.className, message: options.message, action: options?.action
                ? mkAction(toastProps.toastId, options.action)
                : undefined }))),
});
/**
 * Adds a snackbar from outside a React context (like Redux). For React prefer the hook below.
 */
export const addSnackbar = (message, options) => toast(({ toastProps }) => (_jsx(SnackbarContent, { className: options?.className, message: message, action: options?.action
        ? mkAction(toastProps.toastId, options.action)
        : undefined })), toToastOptions({ ...options, snackbarId: options?.snackbarId }));
/**
 * Dismisses a snackbar from outside a React context (like Redux). For React prefer the hook below.
 * If no ID is provided all snackbars are dismissed.
 */
export const dismissSnackbar = (id, containerId) => containerId ? toast.dismiss({ containerId, id }) : toast.dismiss(id);
/**
 * Updates a snackbar from outside a React context (like Redux). For React prefer the hook below.
 */
export const updateSnackbar = (id, options) => toast.update(id, toUpdateToastOptions(options));
/**
 * Exposes a wrapper of the snackbar functions for use in React only.
 * This should allow us to add more React specific functionality if needed in the future.
 */
export const useSnackbar = () => ({
    /**
     * Display a snackbar.
     * The returned `Id` can be used to update or dismiss.
     */
    snackbar: addSnackbar,
    /**
     * Remove a snackbar programmatically. If no ID is provided all snackbars
     * are dismissed.
     */
    dismiss: dismissSnackbar,
    /**
     * Update an active snackbar.
     */
    update: updateSnackbar,
    /**
     * Returns `true` if one container is displaying the snackbar.
     */
    isActive: toast.isActive,
    /**
     *  Clear the queued up snackbars.
     */
    clearQueue: () => toast.clearWaitingQueue(),
});
//# sourceMappingURL=useSnackbar.js.map